import { Popover, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { CustomPicker, CustomPickerProps, SketchPicker } from "react-color";
import { Typography } from "..";

interface ColorPickerProps extends CustomPickerProps<ColorPickerProps> {
  hexCode: string;
}

const ColorPicker = ({ hexCode, onChange }: ColorPickerProps) => {
  return (
    <Popover className="relative">
      {() => (
        <>
          <Popover.Button as="div" className="flex cursor-pointer flex-row">
            <div className="flex items-center justify-center rounded-l-lg border border-r-0 border-neutral-mid-gray bg-neutral-gray p-2.5">
              <div className="h-6 w-6 rounded" style={{ backgroundColor: hexCode }} />
            </div>
            <div className="flex w-36 items-center rounded-r-lg border border-neutral-mid-gray bg-white px-4 py-2.5">
              <Typography variant="paragraph">{hexCode}</Typography>
            </div>
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-10 mt-3 transform sm:px-0 lg:translate-x-[200px] lg:translate-y-[-200px]">
              <SketchPicker color={hexCode} onChange={onChange} disableAlpha />
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default CustomPicker(ColorPicker);
